import { iconTagName } from '@ingka/icon-webc';
import '@ingka/icon-store/warning-triangle';
let dangerButton;
let __inited = false;
export const generateDangerIcon = () => {
    if (!__inited) {
        dangerButton = document.createElement(iconTagName());
        dangerButton.icon = 'warning-triangle';
        __inited = true;
    }
    return dangerButton.cloneNode();
};
